import React, { FC, useEffect } from 'react';
import { Skeleton, Table } from 'antd';
import { WarningCircle } from 'common/svg';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getImproveQscFindingsCollection } from 'app/store/reducers/improveQsc.reducer';
import {
  getImproveQscFindingsConfig,
  IImproveQscFindingsCollectionParams,
} from 'entities/ImproveQsc/ImproveQsc.models';

interface IComponentProps {
  params?: IImproveQscFindingsCollectionParams;
}

export const ImproveQscFindingsBlock: FC<IComponentProps> = ({ params }) => {
  const dispatch = useAppDispatch();

  const { improveQscFindingsCollection, improveQscFindingsCollectionLoading } = useAppSelector(
    (state) => state.improveQsc
  );

  const data = improveQscFindingsCollection?.data ?? [];

  useEffect(() => {
    dispatch(getImproveQscFindingsCollection(params));
  }, [params?.storeCode, params?.week]);

  return (
    <div className="iqsc-block">
      <div className="iqsc-block__header">
        <span className="ff-medium fs-xs">Consecutive Findings</span>
        <WarningCircle className="icon-gray" />
      </div>

      <div className="iqsc-block__body">
        {improveQscFindingsCollectionLoading ? (
          <Skeleton active paragraph={{ rows: 4 }} title={false} />
        ) : (
          <Table
            className="iqsc-findings__table"
            pagination={false}
            dataSource={data.map((i, index) => ({ ...i, key: index }))}
            columns={getImproveQscFindingsConfig()}
            scroll={{ y: 195 }}
          />
        )}
      </div>
    </div>
  );
};
